import { Aparencia } from './Aparencia';
import { CartaoModelos } from './AparenciaModelos';
import { CartaoEstiloWorkspace, CartaoFonteWorkspace, CartaoMarca } from './AparenciaFonteMarca';
import { Empresas } from './Empresas';
import { CartaoExportacoesSemAcesso } from './ExportacoesSemAcesso';
import { Historico, HistoricoAparencia } from './Historico';
import { CartaoTrocaDeEmpresa } from './TrocaDeEmpresa';

/** Aba `empresa`: empresas do grupo e o histórico delas. */
export function AbaEmpresa() {
  return (
    <div className="flex min-w-0 flex-col gap-4">
      <Empresas />
      <CartaoTrocaDeEmpresa />
      <CartaoExportacoesSemAcesso />
      <Historico entidade="configuracoes.empresa" />
    </div>
  );
}

/** Aba `aparencia` (M13.6; fase 2, W4): acento, tema e idioma padrão, fonte do texto e marca do workspace, com histórico. */
export function AbaAparencia() {
  return (
    <div className="grid min-w-0 gap-4 xl:grid-cols-2">
      <Aparencia />
      <CartaoMarca />
      <CartaoFonteWorkspace />
      <CartaoEstiloWorkspace />
      <CartaoModelos />
      <div className="min-w-0 xl:col-span-2">
        <HistoricoAparencia />
      </div>
    </div>
  );
}
